import http from "./http";
import jwtDecode from "jwt-decode";

const apiEndPoint = "/auth";
const tokenKey = "ftr-token";

http.setToken(getToken());

async function login(username, password, site) {
  const rememberMe = localStorage.getItem("ftr-remember-me");
  const source = "Web";

  try {
    const { data: jwt } = await http.post(apiEndPoint, {
      username,
      password,
      site,
      source
    });
    
    if (rememberMe === true || rememberMe === "true") {
      localStorage.setItem(tokenKey, jwt);
    } else {
      sessionStorage.setItem(tokenKey, jwt);
    }
  }
  catch {
    //ignore error
  }
}

function logout() {
  localStorage.removeItem(tokenKey);
  sessionStorage.removeItem(tokenKey);
}

function getCurrentUser() {
  try {
    const rememberMe = localStorage.getItem("ftr-remember-me");
    if (rememberMe === true || rememberMe === "true") {
      const jwt = localStorage.getItem(tokenKey);
      return jwtDecode(jwt);
    } else {
      const jwt = sessionStorage.getItem(tokenKey);
      return jwtDecode(jwt);
    }
  } catch (ex) {
    return null;
  }
}

function getUserPermission(property) {
  try {
    const jwt = getToken();
    const user = jwtDecode(jwt);
    return user[property];
  } catch (ex) {
    return false;
  }
}

function getToken() {
  const rememberMe = localStorage.getItem("ftr-remember-me");
  if (rememberMe === true || rememberMe === "true") {
    return localStorage.getItem(tokenKey);
  } else {
    return sessionStorage.getItem(tokenKey);
  }
}

function updateToken(token) {
  const rememberMe = localStorage.getItem("ftr-remember-me");
  if (rememberMe === true || rememberMe === "true") {
    localStorage.setItem(tokenKey, token);
  } else {
    sessionStorage.setItem(tokenKey, token);
  }
  http.setToken(getToken());
}

export default {
  login,
  logout,
  getCurrentUser,
  getUserPermission,
  getToken,
  updateToken,
};
